module.exports = __webpack_public_path__ + "img/p_sz_1.a90122d1.svg";